import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { pick } from 'ramda';

import {
    showConfirmMarketingPreferencesPopup
} from '@interlayer/js/app/components/popups/ConfirmMarketingPreferencesPopup/actions';
import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';

import { useDynamicTags } from 'js/app/hooks/useDynamicTags';
import { htcmdService } from 'js/services/htcmd.service';
import { useUserSelector } from 'js/store/hooks';

export const useVerifyMarketingPreferences = () => {
    const { userDetails: userData, allPlayerTags: playerTags } = useUserSelector(pick(['userDetails', 'allPlayerTags']));

    const verifyMarketingPreferences = useVerifyMarketingPreferencesDirect();

    return verifyMarketingPreferences({ playerTags, userData }, true);
};

export const useVerifyMarketingPreferencesDirect = () => {
    const [
        dTagVerifyMarketingPreferencesPlayerTag = 'Athena/marketingprefs'
    ] = useDynamicTags([
        DYNAMIC_TAG_NAMES.verifyMarketingPreferencesPlayerTag
    ]);
    const { isRegistrationInProcess } = useRegistrationSelector();
    const dispatch = useDispatch();

    return useCallback(async (data, isDirectCheck = false) => {
        const { playerTags, userData } = data;

        const shouldShowVerifyMarketingPreferences =
            !Object.entries(playerTags || {}).find(e => e[1].name === dTagVerifyMarketingPreferencesPlayerTag);

        // Native will show their own popup
        if (
            !htcmdService.isEnabled
            && shouldShowVerifyMarketingPreferences
            && userData?.ageVerificationStatus === 'passed'
            && !isRegistrationInProcess
        ) {
            if (isDirectCheck) {
                return true;
            }

            dispatch(showConfirmMarketingPreferencesPopup({}));
        }

        return isDirectCheck ? false : data;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default useVerifyMarketingPreferences;
